import { render, staticRenderFns } from "./IssueTrackingDetail.vue?vue&type=template&id=44c900da"
import script from "./IssueTrackingDetail.vue?vue&type=script&lang=js"
export * from "./IssueTrackingDetail.vue?vue&type=script&lang=js"
import style0 from "./IssueTrackingDetail.vue?vue&type=style&index=0&id=44c900da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports